import { Link } from 'react-router-dom';
import { channels } from '@/mocks/channels';
import { topics } from '@/mocks/topics';
import { contactInfo } from '@/mocks/site';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 pt-14 md:pt-20 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-flashlight-fill text-xl" aria-hidden="true" />
              </span>
              <span className="font-heading text-xl font-bold text-background-50">爆料官网</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200/80 max-w-xs">
              以清晰的栏目与导航结构，聚合可核实的爆料与调查内容，帮助你高效定位感兴趣的领域。
            </p>
            <p className="text-sm text-accent-300 font-heading">{contactInfo.slogan}</p>
          </div>

          <div className="flex flex-col gap-4">
            <h4 className="font-heading text-background-50 text-base">
              <Link to="/channels" className="hover:text-accent-300 transition-colors">
                热门频道
              </Link>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {channels.slice(0, 6).map((c) => (
                <li key={c.slug}>
                  <Link
                    to="/channels"
                    className="text-sm text-background-200/80 hover:text-background-50 transition-colors"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col gap-4">
            <h4 className="font-heading text-background-50 text-base">
              <Link to="/topics" className="hover:text-accent-300 transition-colors">
                专题分类
              </Link>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {topics.map((t) => (
                <li key={t.slug}>
                  <Link
                    to="/topics"
                    className="text-sm text-background-200/80 hover:text-background-50 transition-colors"
                  >
                    {t.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col gap-4">
            <h4 className="font-heading text-background-50 text-base">联系我们</h4>
            <ul className="flex flex-col gap-3 text-sm text-background-200/80">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-300" aria-hidden="true" />
                <span>
                  投稿与线索
                  <br />
                  <a href={`mailto:${contactInfo.email}`} className="text-background-50 hover:text-accent-300 transition-colors">
                    {contactInfo.email}
                  </a>
                </span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-team-line mt-0.5 text-accent-300" aria-hidden="true" />
                <span>
                  内容合作
                  <br />
                  <a href={`mailto:${contactInfo.cooperation}`} className="text-background-50 hover:text-accent-300 transition-colors">
                    {contactInfo.cooperation}
                  </a>
                </span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-accent-300" aria-hidden="true" />
                <span>{contactInfo.replyTime}</span>
              </li>
            </ul>
            <Link
              to="/about"
              className="inline-flex w-fit items-center gap-2 border border-background-50/30 hover:border-accent-300 hover:text-accent-300 text-background-50 text-sm px-4 py-2 rounded-md transition-colors"
            >
              了解内容原则
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-200/60 text-center sm:text-left">
            © {year} 爆料官网 · 内容以公开可查信息为基础，欢迎读者监督与更正
          </p>
          <div className="flex items-center gap-4 text-xs text-background-200/60">
            <Link to="/about" className="hover:text-background-50 transition-colors">关于我们</Link>
            <Link to="/channels" className="hover:text-background-50 transition-colors">频道列表</Link>
            <Link to="/topics" className="hover:text-background-50 transition-colors">专题分类</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}